import { Store } from 'vuex'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.CustomerTypeCreated',
    callback: (type: KwixeoCustomers.CustomerType): void => {
      store.dispatch('customers/setCustomerType', type)
    }
  },
  {
    name: '.CustomerTypeUpdated',
    callback: (type: KwixeoCustomers.CustomerType): void => {
      store.dispatch('customers/setCustomerType', type)
    }
  },
  {
    name: '.CustomerTypeDeleted',
    callback: (type: KwixeoCustomers.CustomerType): void => {
      store.dispatch('customers/deleteCustomerType', type)
    }
  },

  {
    name: '.ContactFunctionCreated',
    callback: (contactFunction: KwixeoCustomers.ContactFunction): void => {
      store.dispatch('customers/setContactFunction', contactFunction)
    }
  },
  {
    name: '.ContactFunctionUpdated',
    callback: (contactFunction: KwixeoCustomers.ContactFunction): void => {
      store.dispatch('customers/setContactFunction', contactFunction)
    }
  },
  {
    name: '.ContactFunctionDeleted',
    callback: (contactFunction: KwixeoCustomers.Origin): void => {
      store.dispatch('customers/deleteContactFunction', contactFunction)
    }
  },

  {
    name: '.OriginCreated',
    callback: (origin: KwixeoCustomers.Origin): void => {
      store.dispatch('customers/setOrigin', origin)
    }
  },
  {
    name: '.OriginUpdated',
    callback: (origin: KwixeoCustomers.Origin): void => {
      store.dispatch('customers/setOrigin', origin)
    }
  },
  {
    name: '.OriginDeleted',
    callback: (origin: KwixeoCustomers.Origin): void => {
      store.dispatch('customers/deleteOrigin', origin)
    }
  },

  {
    name: '.ActivityCreated',
    callback: (activity: KwixeoCustomers.Activity): void => {
      store.dispatch('customers/setActivity', activity)
    }
  },
  {
    name: '.ActivityUpdated',
    callback: (activity: KwixeoCustomers.Activity): void => {
      store.dispatch('customers/setActivity', activity)
    }
  },
  {
    name: '.ActivityDeleted',
    callback: (activity: KwixeoCustomers.Activity): void => {
      store.dispatch('customers/deleteActivity', activity)
    }
  }

])
